import state from './store/state';
import mutations from './store/mutations';
import actions from './store/actions';

const store = {
  namespaced: true,

  state,
  actions,
  mutations,
};

export default store;
